(function () {
  'use strict';

  var API = 'https://api.altitudecraft.com/api/warranty';
  var DRAFT_KEY = 'ac_warranty_draft_v1';
  var RESULT_KEY = 'ac_warranty_result';

  function extractOrderNumber(raw) {
    var s = String(raw == null ? '' : raw).normalize('NFKC').trim();
    if (!s) return null;
    var a = s.match(/(?:^|\D)(\d{3})[-\s]?(\d{7})[-\s]?(\d{7})(?!\d)/);
    if (a) return { kind: 'amazon', number: a[1] + '-' + a[2] + '-' + a[3] };
    var bare = s.match(/^#?\s*(\d{4,6})$/);
    if (bare) return { kind: 'shopify', number: '#' + bare[1] };
    var hashed = s.match(/#\s*(\d{4,6})(?!\d)/);
    if (hashed) return { kind: 'shopify', number: '#' + hashed[1] };
    return null;
  }

  window.ACWarranty = { extractOrderNumber: extractOrderNumber };

  var root = document.querySelector('[data-acw-wizard]');
  if (!root) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  function store(kind) {
    try { return window[kind]; } catch (e) { return null; }
  }
  function readJSON(kind, key) {
    try { var s = store(kind); return s ? JSON.parse(s.getItem(key) || 'null') : null; } catch (e) { return null; }
  }
  function writeJSON(kind, key, value) {
    try { var s = store(kind); if (s) s.setItem(key, JSON.stringify(value)); } catch (e) { /* storage blocked */ }
  }

  var els = {
    step1: $('[data-acw-step="1"]'),
    step2: $('[data-acw-step="2"]'),
    progress: $$('[data-acw-progress] span'),
    stepLabel: $('[data-acw-step-label]'),
    order: $('#acw-order'),
    paste: $('[data-acw-paste]'),
    amazon: $('[data-acw-amazon]'),
    orderHint: $('[data-acw-order-hint]'),
    result: $('[data-acw-result]'),
    manual: $('[data-acw-manual]'),
    product: $('#acw-product'),
    date: $('#acw-date'),
    next: $('[data-acw-next]'),
    back: $('[data-acw-back]'),
    name: $('#acw-name'),
    email: $('#acw-email'),
    gift: $('#acw-gift'),
    marketing: $('#acw-marketing'),
    phone: $('#acw-phone'),
    address: $('#acw-address'),
    city: $('#acw-city'),
    zip: $('#acw-zip'),
    submit: $('[data-acw-submit]'),
    formError: $('[data-acw-form-error]'),
    native: document.getElementById('acw-native')
  };

  var state = { parsed: null, lookup: null, amazonOpened: false, lookupSeq: 0, submitting: false };

  if (els.date) els.date.max = new Date().toISOString().slice(0, 10);

  function setStep(n) {
    els.step1.hidden = n !== 1;
    els.step2.hidden = n !== 2;
    els.progress.forEach(function (bar, i) { bar.classList.toggle('is-on', i < n); });
    if (els.stepLabel) els.stepLabel.textContent = n === 1 ? 'Step 1 of 2 · Find your order' : 'Step 2 of 2 · Where should we send your warranty?';
    var focus = n === 1 ? els.order : els.name;
    if (focus) focus.focus({ preventScroll: false });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function fieldError(input, message) {
    var box = input && root.querySelector('[data-acw-error-for="' + input.id + '"]');
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (box) { box.textContent = message || ''; box.hidden = !message; }
  }

  function clearErrors() {
    $$('[aria-invalid="true"]').forEach(function (el) { fieldError(el, ''); });
    if (els.formError) { els.formError.hidden = true; els.formError.textContent = ''; }
  }

  function saveDraft() {
    writeJSON('localStorage', DRAFT_KEY, {
      order: els.order.value, product: els.product.value, date: els.date.value,
      name: els.name.value, email: els.email.value, phone: els.phone.value,
      address: els.address.value, city: els.city.value, zip: els.zip.value,
      gift: els.gift.checked
    });
  }

  function restoreDraft() {
    var d = readJSON('localStorage', DRAFT_KEY);
    if (!d) return false;
    ['order', 'name', 'email', 'phone', 'address', 'city', 'zip'].forEach(function (k) { if (d[k] && els[k]) els[k].value = d[k]; });
    if (d.product) els.product.value = d.product;
    if (d.date) els.date.value = d.date;
    els.gift.checked = !!d.gift;
    return Boolean(d.order || d.name || d.email);
  }

  function selectedSkus() {
    return $$('[data-acw-item]').filter(function (c) {
      return !c.disabled && (c.type === 'hidden' || c.checked);
    }).map(function (c) { return c.value; });
  }

  function canContinue() {
    if (!state.parsed) return false;
    var L = state.lookup;
    if (L && L.emailCheck && els.manual.hidden) return true;
    if (L && L.found) return !L.allRegistered && selectedSkus().length > 0;
    return Boolean(els.product.value) && Boolean(els.date.value) && els.date.value <= els.date.max;
  }

  function refreshNext() {
    els.next.disabled = !canContinue();
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function niceDate(ymd) {
    var p = String(ymd || '').split('-');
    if (p.length !== 3) return ymd || '';
    var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2]));
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
  }

  function renderLookup(L) {
    els.manual.hidden = true;
    if (!L) { els.result.innerHTML = ''; els.result.hidden = true; refreshNext(); return; }
    els.result.hidden = false;

    if (L.emailCheck) {
      els.result.className = 'acw-result acw-result--info';
      els.result.innerHTML = '<p><strong>Got it — an altitudecraft.com order.</strong> We\u2019ll confirm it with your email in the next step.</p>';
      refreshNext();
      return;
    }

    if (L.found && L.allRegistered) {
      els.result.className = 'acw-result acw-result--warn';
      els.result.innerHTML = '<p><strong>This order is already registered.</strong> We can email the warranty card again to the address used.</p>' +
        '<button type="button" class="acw-link" data-acw-resend>Resend my warranty card</button>';
      refreshNext();
      return;
    }

    if (L.found) {
      var open = L.items.filter(function (i) { return !i.registered; });
      var multi = L.items.length > 1;
      var list = L.items.map(function (i) {
        var dis = i.registered ? ' disabled' : ' checked';
        var tag = i.registered ? ' <span class="acw-muted">(already registered)</span>' : '';
        return multi
          ? '<label class="acw-check"><input type="checkbox" data-acw-item value="' + esc(i.sku || i.name) + '"' + dis + '> <span>' + esc(i.name) + tag + '</span></label>'
          : '<input type="hidden" data-acw-item value="' + esc(i.sku || i.name) + '"' + (i.registered ? ' disabled' : ' checked') + '><strong class="acw-result__name">' + esc(i.name) + '</strong>';
      }).join('');
      els.result.className = 'acw-result acw-result--ok';
      els.result.innerHTML = '<p class="acw-result__title">&#10003; Found your order</p>' +
        (multi ? '<p class="acw-muted">' + open.length + ' item(s) to register:</p>' : '') + list +
        '<p class="acw-muted">Bought ' + esc(niceDate(L.purchaseDate)) + ' · covered until <strong>' + esc(niceDate(L.coverageEnd)) + '</strong></p>';
      refreshNext();
      return;
    }

    els.result.className = 'acw-result acw-result--info';
    els.result.innerHTML = '<p><strong>We couldn\u2019t find this order yet.</strong> New orders can take up to 24 hours to show up. You can still register — just tell us the product and date.</p>';
    els.manual.hidden = false;
    refreshNext();
  }

  function fetchJSON(url, opts, timeoutMs) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, timeoutMs) : null;
    return fetch(url, Object.assign({ signal: ctrl ? ctrl.signal : undefined }, opts || {}))
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; }); })
      .finally(function () { if (timer) clearTimeout(timer); });
  }

  function runLookup() {
    var parsed = extractOrderNumber(els.order.value);
    state.parsed = parsed;
    state.lookup = null;
    fieldError(els.order, '');
    if (!parsed) {
      renderLookup(null);
      if (els.order.value.trim().length >= 8) fieldError(els.order, 'That doesn\u2019t look like an order number. Amazon: 123-1234567-1234567 · Our store: #1234');
      return;
    }
    if (els.order.value !== parsed.number && /^[\s#\d-]+$/.test(els.order.value.normalize('NFKC'))) els.order.value = parsed.number;
    var seq = ++state.lookupSeq;
    els.result.hidden = false;
    els.result.className = 'acw-result';
    els.result.innerHTML = '<p class="acw-muted">Looking up your order…</p>';
    fetchJSON(API + '/lookup?order=' + encodeURIComponent(parsed.number), {}, 6000)
      .then(function (res) {
        if (seq !== state.lookupSeq) return;
        state.lookup = res.status === 200 && res.body.data && res.body.data.valid ? res.body.data : { found: false, items: [] };
        renderLookup(state.lookup);
      })
      .catch(function () {
        if (seq !== state.lookupSeq) return;
        state.lookup = { found: false, items: [] };
        renderLookup(state.lookup);
      });
  }

  var lookupTimer = null;
  els.order.addEventListener('input', function () {
    clearTimeout(lookupTimer);
    lookupTimer = setTimeout(runLookup, 400);
    saveDraft();
  });

  els.paste.addEventListener('click', function () {
    els.paste.classList.remove('is-highlight');
    if (navigator.clipboard && navigator.clipboard.readText) {
      navigator.clipboard.readText().then(function (text) {
        var parsed = extractOrderNumber(text);
        els.order.value = parsed ? parsed.number : text.trim().slice(0, 60);
        runLookup();
        saveDraft();
      }).catch(function () {
        els.order.focus();
        if (els.orderHint) els.orderHint.textContent = 'Press and hold in the box, then tap Paste.';
      });
    } else {
      els.order.focus();
      if (els.orderHint) els.orderHint.textContent = 'Press and hold in the box, then tap Paste.';
    }
  });

  els.amazon.addEventListener('click', function () { state.amazonOpened = true; });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && state.amazonOpened && !state.parsed) els.paste.classList.add('is-highlight');
  });

  els.result.addEventListener('change', refreshNext);
  els.result.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-acw-resend]');
    if (!btn || !state.parsed) return;
    btn.disabled = true;
    btn.textContent = 'Sending…';
    fetchJSON(API + '/resend', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ order: state.parsed.number }) }, 10000)
      .then(function (res) {
        btn.outerHTML = '<p>If this order is registered, we\u2019ve emailed the warranty card to the address used. Not there in 10 minutes? Check spam, or <a href="/pages/contact">submit a support case</a>.</p>';
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Resend my warranty card'; });
  });

  [els.product, els.date].forEach(function (el) { el.addEventListener('change', function () { refreshNext(); saveDraft(); }); });

  els.next.addEventListener('click', function () {
    if (!canContinue()) { refreshNext(); return; }
    setStep(2);
  });
  els.back.addEventListener('click', function () { setStep(1); });

  $$('[data-acw-draft]').forEach(function (el) { el.addEventListener('input', saveDraft); el.addEventListener('change', saveDraft); });

  function payload() {
    var opt = els.product.options[els.product.selectedIndex];
    return {
      order: state.parsed ? state.parsed.number : els.order.value,
      items: state.lookup && state.lookup.found ? selectedSkus() : [],
      product: els.product.value,
      productSku: opt ? opt.getAttribute('data-sku') || null : null,
      purchaseDate: els.date.value,
      name: els.name.value.trim(),
      email: els.email.value.trim(),
      gift: els.gift.checked,
      createAccount: false,
      marketingOptIn: els.marketing.checked,
      phone: els.phone.value.trim(),
      address: els.address.value.trim(),
      city: els.city.value.trim(),
      postalCode: els.zip.value.trim(),
      sourcePage: location.pathname + location.search
    };
  }

  function validateStep2() {
    var ok = true;
    if (!els.name.value.trim()) { fieldError(els.name, 'Please enter your name.'); ok = false; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(els.email.value.trim())) { fieldError(els.email, 'Please enter a valid email address.'); ok = false; }
    var first = root.querySelector('[aria-invalid="true"]');
    if (first) first.focus();
    return ok;
  }

  function setSubmitting(on) {
    state.submitting = on;
    els.submit.disabled = on;
    els.submit.textContent = on ? 'Activating…' : els.submit.getAttribute('data-label');
  }

  function nativeFallback(p) {
    if (!els.native) return false;
    var body = ['[WARRANTY REGISTRATION – fallback]', 'Order: ' + p.order, 'Items: ' + (p.items.join(', ') || p.product),
      'Purchase date: ' + (p.purchaseDate || (state.lookup && state.lookup.purchaseDate) || ''), 'Gift: ' + (p.gift ? 'yes' : 'no'),
      'Account invite: ' + (p.createAccount ? 'yes' : 'no'), 'Marketing opt-in: ' + (p.marketingOptIn ? 'yes' : 'no'),
      'Phone: ' + p.phone, 'Address: ' + [p.address, p.city, p.postalCode].filter(Boolean).join(', ')].join('\n');
    els.native.querySelector('[name="contact[name]"]').value = p.name;
    els.native.querySelector('[name="contact[email]"]').value = p.email;
    els.native.querySelector('[name="contact[body]"]').value = body;
    // requestSubmit fires the submit event so Shopify's hCaptcha handler can attach its token
    if (typeof els.native.requestSubmit === 'function') els.native.requestSubmit(); else els.native.submit();
    return true;
  }

  function onSuccess(data) {
    if (data.duplicate && !data.sameOwner) {
      setSubmitting(false);
      setStep(1);
      els.result.hidden = false;
      els.result.className = 'acw-result acw-result--warn';
      els.result.innerHTML = '<p><strong>This order is already registered.</strong> We can email the warranty card again to the address used.</p>' +
        '<button type="button" class="acw-link" data-acw-resend>Resend my warranty card</button>';
      return;
    }
    writeJSON('sessionStorage', RESULT_KEY, data);
    writeJSON('localStorage', DRAFT_KEY, { name: els.name.value, email: els.email.value });
    location.href = '/pages/warranty-registered';
  }

  els.submit.addEventListener('click', function () {
    if (state.submitting) return;
    clearErrors();
    if (!validateStep2()) return;
    var p = payload();
    setSubmitting(true);
    fetchJSON(API + '/register', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(p) }, 15000)
      .then(function (res) {
        if (res.status === 200 && res.body.success) return onSuccess(res.body.data);
        setSubmitting(false);
        if (res.status === 400 && res.body.field) {
          var map = { order: els.order, product: els.product, purchaseDate: els.date, name: els.name, email: els.email };
          var input = map[res.body.field];
          if (input === els.product || input === els.date) {
            els.manual.hidden = false;
            els.result.hidden = false;
            els.result.className = 'acw-result acw-result--info';
            els.result.innerHTML = '<p><strong>We couldn\u2019t match this order to your email.</strong> Tell us the product and purchase date and we\u2019ll verify it by hand.</p>';
          }
          if (input && (input === els.order || input === els.product || input === els.date)) setStep(1);
          fieldError(input, res.body.error);
          if (input) input.focus();
          return;
        }
        if (res.status === 429) {
          els.formError.textContent = 'Too many attempts. Please wait a minute and try again — your details are saved.';
          els.formError.hidden = false;
          return;
        }
        if (!nativeFallback(p)) { els.formError.textContent = 'Something went wrong. Your details are saved — please try again.'; els.formError.hidden = false; }
      })
      .catch(function (err) {
        setSubmitting(false);
        if (err && err.name === 'AbortError') {
          // The server may already have registered it — a fallback submit here would create a duplicate.
          els.formError.textContent = 'This is taking longer than usual. We may already have your registration — please check your email in a few minutes before trying again.';
          els.formError.hidden = false;
          return;
        }
        if (!nativeFallback(p)) { els.formError.textContent = 'Network problem. Your details are saved — please try again.'; els.formError.hidden = false; }
      });
  });

  // ---- boot ----
  var params = new URLSearchParams(location.search);
  if (params.get('contact_posted') === 'true') {
    els.step1.hidden = true;
    els.step2.hidden = true;
    return;
  }
  var restored = restoreDraft();
  if (params.get('again') === '1') { els.order.value = ''; els.product.value = ''; els.date.value = ''; }
  var sku = params.get('sku');
  if (sku) {
    var match = Array.prototype.find.call(els.product.options, function (o) { return (o.getAttribute('data-sku') || '').toUpperCase().indexOf(sku.toUpperCase()) === 0; });
    if (match) els.product.value = match.value;
  }
  if (params.get('order')) els.order.value = params.get('order');
  if (els.order.value) runLookup();
  if (restored && root.querySelector('[data-acw-restored]')) root.querySelector('[data-acw-restored]').hidden = false;
  refreshNext();
})();
